import type { MainNavigationGroupedBlock } from '@ps/web-martech-cms-types/SiteHeader';
import classNames from 'clsx';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { CMSMenuItemsPrototype4, CMSResolverLink } from '@swf/cms';

import styles from './SideMenuPrototype4.scss';
import Icon from './components/Icon';

interface SideMenuProps {
  items: MainNavigationGroupedBlock[];
  className?: string;
}

const SideMenuPrototype4: React.FC<SideMenuProps> = ({ items, className }) => {
  const { pathname } = useLocation();
  const subHeaderUrls = useMemo(() => CMSMenuItemsPrototype4.flatMap((item) => item.url), []);
  const isOnPokerLobbies = useMemo(
    () => subHeaderUrls.some((url) => pathname.startsWith(url)),
    [subHeaderUrls, pathname]
  );
  const SPIN_AND_GO_URL = '/poker/play-poker/spin-and-go/';

  const isActive = useCallback(
    (url: string) => (isOnPokerLobbies && url === SPIN_AND_GO_URL) || pathname.startsWith(url),
    [isOnPokerLobbies, pathname]
  );

  return (
    <div className={classNames(styles.container, className)}>
      {items.map((group, groupIdx) => (
        <ul className={styles.list} key={groupIdx}>
          {group.group?.map((item) => (
            <li key={item.url} className={classNames(styles.menuItem)}>
              <CMSResolverLink
                className={classNames({ [styles.active]: item.url && isActive(item.url) })}
                activeClassName={styles.active}
                showTitle
                customIcon={<Icon icon={item.icon} />}
                {...item}
              />
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
};
export default SideMenuPrototype4;
